<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="container">
    <div class="row">
        <div class="col-24">
            <h1>User Profile</h1>
        </div>
    </div>
    <div class="row" *ngIf="viewprofile">
        <div class="col-24">
            <h2>Please login in to Producer World to perform profile edits <a class="active" style="padding-left:20px;" (click)="Pwurl()" target="_blank"> Producer World</a>
            </h2>
        </div>
    </div>
    <button #focusableEleTop class="focusable-element"></button>
    <!--<div class="row">
        <div class="col-24">
            <h1>{{pageTitle}}</h1>

        </div>
    </div>-->
<div class="row">
    <div class="col-8">
        <div class="input-wrapper">
            <ValidatedTextField [label]="'Login ID'"
                                [disabled]="disableLogIn"
                                [text]="userProfile.UserProfileName"
                                maxlength="50">
            </ValidatedTextField>
        </div>
    </div>
    <div class="col-8" id="divChangePwd" *ngIf="isChangePassword" style="display: block;">
        <div class="input-wrapper">
            <a (click)="changePwdNavigation()" style="margin-top: 35px;">Change Password</a>
        </div>
    </div>



    <!--<div class="col-8" *ngIf="isAddMode">
        <div class="input-wrapper">
            <div>
                <ValidatedTextField class="field"
                                    id="password"
                                    label="Password"
                                    [text]="personalDetails.LoginPassword"
                                    type="password"
                                    (onValueChange)="personalDetails.LoginPassword = $event">
                </ValidatedTextField>-->
    <!--<label>Password</label>
    <ObfuscatedTextField (onValueChange)="personalDetails.LoginPassword = $event"
                         fieldId="pwd"
                         [text]="personalDetails.LoginPassword">
    </ObfuscatedTextField>-->
    <!--</div>
        </div>
    </div>
    <div class="col-8" *ngIf="isAddMode">
        <div class="instructions-list">
            <span><strong>The password must:</strong></span>
            <ul>
                <li>Be a minimum length of 12 characters</li>
                <li>Contain at least 1 upper-case letter</li>
                <li>Contain at least 1 lower-case letter</li>
                <li>Contain at least 1 special non-alpha-character</li>
                <li>Contain at least 1 number</li>
                <li>No character can occur 3 times consecutively</li>
                <li>You cannot re-use any of your previous 8 passwords</li>
            </ul>
        </div>
    </div>-->
</div>
    <div class="row" id="divUserTypeAndOrg">
        <div class="col-8">
            <!--<ValidatedTextField [label]="'Organization'"
                            [disabled]="disableLogIn"
                            [text]="orgListString">
        </ValidatedTextField>

        <input readonly="readonly" value="{{this.orgListString}}"  />-->
            <label>Organization</label>
            <p>{{this.orgListString}}</p>
        </div>
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'User Type'"
                                    [disabled]="disableLogIn"
                                    [text]="userOrgRoleDetails.RoleName">
                </ValidatedTextField>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-6" id="divEmpID" *ngIf="displayEmpID">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Employee ID'"
                                    [text]="userProfile.UID"
                                    [disabled]="disableLogIn" 
                                    maxlength="7">
                </ValidatedTextField>
            </div>
        </div>
    </div>
</div>

<fieldset>
    <legend>Personal Information</legend>
    <div class="row">
        <div class="col-6">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'First Name'"
                                    [text]="userProfile.FirstName"
                                    [disabled]="disableLogIn"
                                    (onValueChange)="userProfile.FirstName = $event" maxlength="50">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-4">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Middle Name'"
                                    [disabled]="disableLogIn"
                                    [text]="userProfile.MiddleName"
                                    (onValueChange)="userProfile.MiddleName = $event">

                </ValidatedTextField>
            </div>
        </div>
        <div class="col-6">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Last Name'"
                                    [disabled]="disableLogIn"
                                    [text]="userProfile.LastName"
                                    (onValueChange)="userProfile.LastName = $event" maxlength="50">
                </ValidatedTextField>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField class="field"
                                    [label]="'Email'"
                                    id="email"
                                    [disabled]="disableLogIn"
                                    [text]="userProfile.Email">
                </ValidatedTextField>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-6" style="display:none" id="divDOB">
            <div class="input-wrapper">
                <ValidatedDateTextField [label]="'Date of Birth'"
                                        id="dateofBirth"
                                        [date]="userProfile.dateofBirth">
                </ValidatedDateTextField>
            </div>
        </div>
    </div>

    <div id="divBgAndStatus" *ngIf="showBgcData">
        <div class="row">
            <div class="col-16" id="divBG">
                <p class="detail-info">
                    Background questionnaire completed?

                    <span>{{ userBackGroundCheck.BGCheck }}</span>
                    <span>{{ userBackGroundCheck.BackGroundCheckDateStr | onlyDateFormat}} </span>
                </p>
            </div>
        </div>
        <div class="row" id="divStatus">
            <div class="col-5">
                <div class="input-wrapper">
                    <ValidatedTextField class="field"
                                        [label]="'Background check result'"
                                        id="BackgroundcheckResult"
                                        [text]="userBackGroundCheck.BGApprovedValue"
                                        [disabled]="disableLogIn">
                    </ValidatedTextField>
                </div>
            </div>
            <div class="col-3">
                <div class="input-wrapper">
                    <p class="top-padding"> {{ userBackGroundCheck.BgApprovedDate | onlyDateFormat }}</p>
                </div>
            </div>

            <div class="col-4">
                <div class="input-wrapper">
                    <ValidatedTextField class="field"
                                        [label]="'User Status'"
                                        id="userStatus"
                                        [text]="userProfile.ProfileStatusDescription"
                                        [disabled]="disableLogIn">
                    </ValidatedTextField>
                </div>
            </div>
            <div id="divStatusreason" style="display:none" class="col-4">
                <div class="input-wrapper">
                    <ValidatedTextField class="field"
                                        [label]="'Status Reason'"
                                        id="statusReason"
                                        [text]="userProfile.UserProfileStatusReason"
                                        [disabled]="disableLogIn">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
    </div>
</fieldset>
<fieldset *ngIf="isBusinessAddressTypeAllowed && businessAddress !== undefined">
    <legend>{{businessAddressTypeCustomName}}</legend>

    <div class="row">
        <div class="col-8">
            <div class="input-wrapper" >
                <ValidatedTextField [label]="'Address 1'"
                                    [text]="businessAddress.AddressLine1"
                                    [disabled]="disableLogIn">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Address 2 (optional)'"
                                    [text]="businessAddress.AddressLine2"
                                    [disabled]="disableLogIn">
                </ValidatedTextField>
            </div>
        </div>
    </div>

    <!--<div>Address Group</div>-->
    <div class="row">
        <div class="col-6">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'City'"
                                    [text]="businessAddress.City"
                                    [disabled]="disableLogIn">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-5">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'State'"
                                    [text]="businessAddress.State"
                                    [disabled]="disableLogIn">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-3">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'ZIP Code'"
                                    [text]="businessAddress.Zip"
                                    [disabled]="disableLogIn">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-4">
            <div class="input-wrapper">
                <ValidatedTextField class="zip4"
                                    [label]="'ZIP+4 (optional)'"
                                    [text]="businessAddress.Zip4"
                                    [disabled]="disableLogIn">
                </ValidatedTextField>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Phone Number'"
                                    [disabled]="disableLogIn"
                                    [text]="phoneNum">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Cell Number (optional)'"
                                    [disabled]="disableLogIn"
                                    [text]="cellNum">
                </ValidatedTextField>
            </div>
        </div>
    </div>
</fieldset>
<fieldset *ngIf="isBusinessAddressTypeAllowed && businessAddress === undefined">
    <legend>{{businessAddressTypeCustomName}}</legend>

    <div class="row">
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Address 1'"
                                    [text]=""
                                    [disabled]="disableLogIn">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Address 2 (optional)'"
                                    [text]=""
                                    [disabled]="disableLogIn">
                </ValidatedTextField>
            </div>
        </div>
    </div>

    <!--<div>Address Group</div>-->
    <div class="row">
        <div class="col-6">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'City'"
                                    [text]=""
                                    [disabled]="disableLogIn">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-5">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'State'"
                                    [text]=""
                                    [disabled]="disableLogIn">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-3">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'ZIP Code'"
                                    [text]=""
                                    [disabled]="disableLogIn">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-4">
            <div class="input-wrapper">
                <ValidatedTextField class="zip4"
                                    [label]="'ZIP+4 (optional)'"
                                    [text]=""
                                    [disabled]="disableLogIn">
                </ValidatedTextField>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Phone Number'"
                                    [disabled]="disableLogIn"
                                    [text]="phoneNum">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Cell Number (optional)'"
                                    [disabled]="disableLogIn"
                                    [text]="cellNum">
                </ValidatedTextField>
            </div>
        </div>
    </div>
</fieldset>

<fieldset *ngIf="isHomeAddressTypeAllowed && residentialAddress !== undefined">
    <legend>{{homeAddressTypeCustomName}}</legend>
    <div class="row">
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Address 1'"
                                    [text]="residentialAddress.AddressLine1"
                                    [disabled]="disableLogIn">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Address 2 (optional)'"
                                    [text]="residentialAddress.AddressLine2"
                                    [disabled]="disableLogIn">
                </ValidatedTextField>
            </div>
        </div>
    </div>

    <!--<div>Address Group</div>-->
    <div class="row">
        <div class="col-6">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'City'"
                                    [text]="residentialAddress.City"
                                    [disabled]="disableLogIn">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-5">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'State'"
                                    [text]="residentialAddress.State"
                                    [disabled]="disableLogIn">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-3">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'ZIP Code'"
                                    [text]="residentialAddress.Zip"
                                    [disabled]="disableLogIn">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-4">
            <div class="input-wrapper">
                <ValidatedTextField class="zip4"
                                    [label]="'ZIP+4 (optional)'"
                                    [text]="residentialAddress.Zip4"
                                    [disabled]="disableLogIn">
                </ValidatedTextField>
            </div>
        </div>
    </div>
</fieldset>

<fieldset *ngIf="isHomeAddressTypeAllowed && residentialAddress === undefined">
    <legend>{{homeAddressTypeCustomName}}</legend>
    <div class="row">
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Address 1'"
                                    [text]=""
                                    [disabled]="disableLogIn">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-8">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'Address 2 (optional)'"
                                    [text]=""
                                    [disabled]="disableLogIn">
                </ValidatedTextField>
            </div>
        </div>
    </div>

    <!--<div>Address Group</div>-->
    <div class="row">
        <div class="col-6">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'City'"
                                    [text]=""
                                    [disabled]="disableLogIn">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-5">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'State'"
                                    [text]=""
                                    [disabled]="disableLogIn">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-3">
            <div class="input-wrapper">
                <ValidatedTextField [label]="'ZIP Code'"
                                    [text]=""
                                    [disabled]="disableLogIn">
                </ValidatedTextField>
            </div>
        </div>
        <div class="col-4">
            <div class="input-wrapper">
                <ValidatedTextField class="zip4"
                                    [label]="'ZIP+4 (optional)'"
                                    [text]=""
                                    [disabled]="disableLogIn">
                </ValidatedTextField>
            </div>
        </div>
    </div>
</fieldset>

<fieldset>
    <legend>Profile Settings</legend>
    <div class="row" *ngIf="!isEContracting && !isOrgCommissionable && !isTextOptInAvailale && !showUserStatusInSettings">
        <div class="col-24">
            <strong><em>Profile settings are not available for your hierarchy.</em></strong>
        </div>
    </div>
    <div class="row">
        <div class="col-4" *ngIf="isEContracting">
            <div class="input-wrapper">
                <ValidatedDropDown class="wide" [label]="'E-Contract on File'"
                                   [disabled]="disableLogIn"
                                   [options]="eContractOnFile"
                                   [selectedValue]="userProfile.AttestationAccepted">
                </ValidatedDropDown>
            </div>
        </div>
        <div class="col-7">
            <div class="input-wrapper" *ngIf="isOrgCommissionable">
                <label>Commission Level</label>
                <ValidatedTextField class=""
                                    [disabled]="disableLogIn"
                                    [text]="userProfile.CommissionLevel">
                </ValidatedTextField>
            </div>
        </div>

        <div class="col-7">
            <div class="input-wrapper" *ngIf="isOrgCommissionable">
                <label>Agreement Version Number</label>
                <ValidatedTextField class=""
                                    [disabled]="disableLogIn"
                                    [text]="userProfile.AgreementVersionNumber">
                </ValidatedTextField>
            </div>
        </div>


    </div>
    <div class="row" *ngIf="isOrgCommissionable && userProfile.eContractChange">
        <div class="col-16">
            <div class="detail-info">
                <div> {{ userProfile.AttestedDetails }}</div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-7" *ngIf="isOrgCommissionable">
            <div class="input-wrapper">
                <label>NPN <span *ngIf="!isRequired"><strong>(optional)</strong></span></label>
                <ValidatedTextField class="field"
                                    [disabled]="disableLogIn"
                                    [text]="userProfile.NIPR"></ValidatedTextField>
            </div>
        </div>
        <div class="col-5" *ngIf="isTextOptInAvailale">
            <div class="input-wrapper">
                <ValidatedDropDown class="wide"
                                   [label]="'Text Message Opt In'"
                                   [disabled]="disableLogIn"
                                   [options]="textMsgOptIn"
                                   [selectedValue]="userProfile.TextMessageOptIn">
                </ValidatedDropDown>
            </div>
        </div>
       

        <div id="divUserStatusInSettings" *ngIf="showUserStatusInSettings">
            <div class="col-4">
                <div class="input-wrapper">
                    <ValidatedTextField class="field"
                                        [label]="'User Status'"
                                        id="userStatus"
                                        [text]="userProfile.ProfileStatusDescription"
                                        [disabled]="disableLogIn">
                    </ValidatedTextField>
                </div>
            </div>
            <div id="divStatusreason" style="display:none" class="col-4">
                <div class="input-wrapper">
                    <ValidatedTextField class="field"
                                        [label]="'Status Reason'"
                                        id="statusReason"
                                        [text]="userProfile.UserProfileStatusReason"
                                        [disabled]="disableLogIn">
                    </ValidatedTextField>
                </div>
            </div>

        </div>
    </div>

    <!-- <div class="row">
         <div class="col-10">
             <div class="input-wrapper">

                 <ValidatedCheckbox [id]="'Opt-in-to-Silver-Mail-notifications'"
                                    [label]="'Opt-in to Silver Mail Notifications'"
                                    [disabled]="disableLogIn"
                                    [checked]="userProfile.SilverMailOptIn"
                                    (onValueChange)="userProfile.SilverMailOptIn= $event">
                 </ValidatedCheckbox>
             </div>
    </div>
    </div>-->
    <div class="row">
        <div class="col-16" id="divProfileHistory" style="display:none">
            <p class="bottom-10">Profile created by {{ userProfile.RecCreateUserID }} on {{ userProfile.RecCreateTSString }}.</p>
            <p class="bottom-10">Last log in: {{ userProfile.LastSuccesfulLogonDateStr }}</p>
        </div>
    </div>

        <!--<div class="row">
            <div class="col-16">
                <ErrorMessages [errorMessages]="errorMessages"></ErrorMessages>
            </div>
        </div>-->

</fieldset>

<div class="row">
    <div class="col-24" id="divEdit">
        <button class="button cancel" id="cancel" (click)="Cancel()" *ngIf="Editviewprofile">Cancel</button>
        <button class="button primary"  (click)="back()" *ngIf="!viewprofile">Back</button>
        <button class="button primary" (click)="editProfile()"  *ngIf="!viewprofile">Edit</button>
    </div>
</div>

<div class="row">
    <div class="col-24" id="divEdit">
        <div class="tabs">
            <button *ngIf="showCommentsTab" (click)="showTabbed(1)" [ngClass]="{'on': commentsScreenShow}" aria-controls="panel-comments" id="comments" role="tab">Comments</button>
            <button *ngIf="showLicenseTab" (click)="showTabbed(2)" [ngClass]="{'on': licenseScreenShow}" aria-controls="panel-license" id="license" role="tab">License</button>
            <button *ngIf="showTrainingTab" (click)="showTabbed(3)" [ngClass]="{'on': trainingScreenShow}" aria-controls="panel-training" id="training" role="tab">Training</button>
        </div>
        <div *ngIf="commentsScreenShow" aria-labelledby="comments" aria-live="assertive" id="panel-comments" role="tabpanel">
            <div class="row">
                <div class="col-24">
                    <table class="table-striped table-hover custom-table">
                        <tr>
                            <th>Date Added</th>
                            <th>Comments</th>
                            <th>Added By</th>
                        </tr>
                        <tr *ngFor="let c of commentsViewModel">
                            <td>{{c.RecCreateTS | dateFormat}}</td>
                            <td>{{c.Comment}}</td>
                            <td>{{c.RecCreateUserID}}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>

        <div *ngIf="licenseScreenShow" aria-labelledby="license" aria-live="assertive" id="panel-license" role="tabpanel">
            <div class="row">
                <div class="col-24">
                    <table class="table-text-small licence-table">
                        <thead>
                            <tr>
                                <th>State</th>
                                <th>State License #</th>
                                <th>License Expiration Date(mm/dd/yyyy)</th>
                                <th>License Status</th>
                                <th>Source</th>
                                <th *ngIf="showAppt">Record Locked</th>
                                <th *ngIf="showAppt">Appointment Status</th>
                                <th *ngIf="showAppt">Appointment Data Source</th>
                                <th *ngIf="showAppt">Appointment Date</th>
                                <th *ngIf="showAppt">Appointment Termination Date</th>                                
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let l of licenseViewModel; let i = index">
                                <td>
                                    {{l.StateAbbr}}
                                </td>
                                <td>
                                    <div *ngIf="l.EditRow && index==i;else other_content_licenseNumber">

                                    </div>

                                    <ng-template #other_content_licenseNumber>{{l.LicenseNumber}}</ng-template>

                                    <input type="text" name="LicenseNumber{{i}}" id="LicenseNumber{{i}}" [(ngModel)]="licenseViewModel[i].LicenseNumber" *ngIf="l.EditRow && index==i"
                                           value="{{l.LicenseNumber}}" />
                                </td>
                                <td>
                                    <div *ngIf="l.EditRow && index==i;else other_content_licenseExpirationDate">

                                    </div>

                                    <ng-template #other_content_licenseExpirationDate>{{l.LicenseDate}}</ng-template>
                                    <input type="text" name="LicenseExpirationDate{{i}}" helperText="Format as MM/DD/YYYY" id="LicenseExpirationDate{{i}}" [(ngModel)]="licenseViewModel[i].LicenseDate" *ngIf="l.EditRow && index==i"
                                           value="{{l.LicenseDate}}" />

                                </td>
                                <td>
                                    <div *ngIf="l.EditRow && index==i;else other_content_licenseStatusId">

                                    </div>

                                    <ng-template #other_content_licenseStatusId>{{l.Status}}</ng-template>


                                    <select name="LicenseStatusId{{i}}" id="LicenseStatusId{{i}}" [(ngModel)]="licenseViewModel[i].Status" *ngIf="l.EditRow && index==i">
                                        <option *ngFor="let licStatus of allLicenseStatus" value={{licStatus.LicenseStatus}}>
                                            {{licStatus.LicenseStatus}}
                                        </option>
                                    </select>

                                </td>
                                <td>{{l.DataSource}}</td>
                                <td *ngIf="showAppt">
                                    <input type="checkbox" class="option__input"
                                           name="RecordLocked{{i}}"
                                           id="RecordLocked{{i}}"
                                           disabled="{{l.checkboxDisable}}"
                                           [(ngModel)]="licenseViewModel[i].RecordLocked" />
                                    <label for="RecordLocked{{i}}"></label>

                                </td>
                                <td *ngIf="showAppt">{{l.AppointmentStatusName}}</td>
                                <td *ngIf="showAppt">{{l.Source}}</td>
                                <td *ngIf="showAppt">{{l.Effectivedate}}</td>
                                <td *ngIf="showAppt">{{l.ExpirationDate}}</td>                               
                            </tr>
                            
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
        <div *ngIf="trainingScreenShow" aria-labelledby="training" aria-live="assertive" id="panel-training" role="tabpanel">
            <UserDetailTraining [UserProfileID]="selectedUserprofileID"></UserDetailTraining>
        </div>
    </div>
</div>
